module.exports = __webpack_public_path__ + "static/img/goal-10.bfab77c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/goal-10.png
// module id = bEiK
// module chunks = 2